import API from "../../../../../services/api";


export const RESPUESTAS_SOLICITUD_API = {
    get: async (page = 1, id = null) => {
        return await API.get(`/respuestas_solicitudes?page=${page}${id ? `&solicitud_id=${id}` : ''}`).then(res => res.data);
    }
}